import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from 'web-library';
import DialogActions from 'web-library/stories/molecule/DialogActions/DialogActions';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { PaymentMethod } from './PaymentButton';

const useStyles = makeStyles()((theme) =>
({
  paymentMethodButton: {
    marginBottom: theme.spacing(2),
  },
}));

export interface PaymentMethodsModalProps {
  paymentMethodsAvailable: Array<PaymentMethod>;
  modelOpen: boolean;
  onClose: () => void;
  onClickCheckout: (selectedPaymentMethod: PaymentMethod) => void;
  isDisabled: boolean;
  customPaymentMessage?: string;
}

const PaymentMethodsModal = ({
  paymentMethodsAvailable,
  modelOpen = false,
  onClose,
  isDisabled = false,
  onClickCheckout,
  customPaymentMessage,
}: PaymentMethodsModalProps) => {
  const { classes } = useStyles();

  return (
    <Dialog open={modelOpen} maxWidth="sm">
      <DialogTitle>Select Payment Method</DialogTitle>

      <DialogContent>
        {customPaymentMessage && paymentMethodsAvailable.length > 0 && (
          <DialogContentText>
            <Typography variant="body1" className={classes.paymentMethodButton}>
              {customPaymentMessage}
            </Typography>
          </DialogContentText>
        )}
        {paymentMethodsAvailable.includes(PaymentMethod.ENETS_CREDIT_CARD) && (
          <DialogContentText>
            <Button
              className={
                paymentMethodsAvailable.includes(PaymentMethod.PAYNOW_QR) ||
                  paymentMethodsAvailable.includes(PaymentMethod.BANK_TRANSFER)
                  ? classes.paymentMethodButton
                  : ''
              }
              id="button-paymentMethod-enetsCreditCard"
              disabled={isDisabled}
              onClick={() => onClickCheckout(PaymentMethod.ENETS_CREDIT_CARD)}
              fullWidth
            >
              Credit/Debit Card
            </Button>
          </DialogContentText>
        )}
        {paymentMethodsAvailable.includes(PaymentMethod.PAYNOW_QR) && (
          <DialogContentText>
            <Button
              className={
                paymentMethodsAvailable.includes(PaymentMethod.BANK_TRANSFER)
                  ? classes.paymentMethodButton
                  : ''
              }
              id="button-paymentMethod-paynowQr"
              disabled={isDisabled}
              onClick={() => onClickCheckout(PaymentMethod.PAYNOW_QR)}
              fullWidth
            >
              PayNow
            </Button>
          </DialogContentText>
        )}
        {paymentMethodsAvailable.includes(PaymentMethod.BANK_TRANSFER) && (
          <DialogContentText>
            <Button
              id="button-paymentMethod-bankTransfer"
              disabled={isDisabled}
              onClick={() => onClickCheckout(PaymentMethod.BANK_TRANSFER)}
              fullWidth
            >
              Bank Transfer
            </Button>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button type="button" variant="text" onClick={() => onClose()}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentMethodsModal;
